"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var KnockoutComponent = /** @class */ (function (_super) {
    __extends(KnockoutComponent, _super);
    function KnockoutComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KnockoutComponent.prototype.componentDidMount = function () {
        var node = ReactDOM.findDOMNode(this);
        ko.applyBindings(this.props.vm, node);
        var focus = this.props.focusElementSelector;
        if (!focus || node == null || !node.querySelector)
            return;
        node = node;
        var focusNode = node.querySelector(focus);
        if (!focusNode) {
            console.warn("Tried to focus element " + focus + ", but it wasn't found");
            return;
        }
        if (!focusNode.focus) {
            console.warn("Tried to focus element " + focus + ", but it didn't have a .focus() method: " + focusNode);
            return;
        }
        requestAnimationFrame(function () { return focusNode.focus(); });
    };
    KnockoutComponent.prototype.componentWillUnmount = function () {
        ko.cleanNode(ReactDOM.findDOMNode(this));
    };
    KnockoutComponent.prototype.shouldComponentUpdate = function () {
        return false;
    };
    KnockoutComponent.prototype.render = function () {
        return this.props.content;
    };
    return KnockoutComponent;
}(React.Component));
exports.KnockoutComponent = KnockoutComponent;
